import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFolderAdd = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.974 15.654c0 3.355-1.977 5.333-5.333 5.333H8.345C4.98 20.987 3 19.009 3 15.654V8.341c0-3.35 1.232-5.328 4.588-5.328h1.875a2.14 2.14 0 0 1 1.71.856l.857 1.139a2.15 2.15 0 0 0 1.712.856h2.653c3.363 0 4.605 1.712 4.605 5.134z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.298 13.195H9.703m2.299 2.298v-4.595"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFolderAdd);
export default ForwardRef;
